export const TEST_IDS = {
  pendingButton: 'pending-button',
  getApprovalButton: 'get-approval-button',
  acceptButton: 'accept-button',
  declineButton: 'decline-button',
  approvedText: 'approved-text',
}
